import { ReactNode } from 'react';
import { CoreBox, CoreTypography } from '@youscience/core';

import { sxStyles } from './SchoolInfographicItem.styles';

interface SchoolInfographicItemProps {
  icon: ReactNode;
  title: string;
  value?: string | number;
}

export const SchoolInfographicItem = (props: SchoolInfographicItemProps) => {
  const { icon, title, value } = props;

  return (
    <CoreBox sx={sxStyles.infographicItemContainer}>
      <CoreTypography sx={sxStyles.infographicTitle} component="span" variant="caption">
        {title}
      </CoreTypography>

      {value ? (
        <CoreBox sx={sxStyles.itemValueContainer}>
          {icon}

          <CoreTypography sx={sxStyles.itemValue} component="span" variant="overline">
            {value}
          </CoreTypography>
        </CoreBox>
      ) : (
        '–'
      )}
    </CoreBox>
  );
};
